import { BreadCrumbLegacy } from '@src/quince-components/src/atoms/breadCrumb/legacy-bread-crumb'

import styles from './breadcrumbs-pdp.module.scss'
import { BreadcrumbsPdpVariantProps } from './breadcrumbs-pdp.types'

/**
 * Legacy presentation. Reaches `BreadCrumbLegacy` directly — the `BreadCrumb` router would re-apply
 * the trim the widget router already did.
 */
export function BreadcrumbsPdpWidgetLegacy({ directory, deviceType, testId }: BreadcrumbsPdpVariantProps) {
  return (
    <div className={styles.container} data-testid={testId}>
      <BreadCrumbLegacy directory={directory} deviceType={deviceType} />
    </div>
  )
}
